<template>
  <product-shipping-methods
    ref="shippingMethodsRef"
    class="mt-4"
    data-test-id="pdp-shipping-methods"
    :disabled="isOutOfStock"
    emit-invalid-selection
    @invalid-selection="handleNextAttribute({ enableBopis: true }, () => handleAttributeSelection())"
  />
</template>

<script lang="ts" setup>
const { isOutOfStock, attributeSelectionFormRef, handleNextAttribute } = usePdp()

const shippingMethodsRef = ref()

const handleAttributeSelection = () => {
  if (attributeSelectionFormRef.value?.validate(true)) shippingMethodsRef.value?.openStoreSearch()
}

defineExpose({
  method: computed(() => shippingMethodsRef.value?.method)
})
</script>
